import { EntityLayout } from '@backstage/plugin-catalog';
import { CICDContent, OverviewContent } from '../../../components/entity-content';
import { CommonEnvComponents } from '@internal/plugin-dynamic-environment';
import { Grid } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';

export const EnvironmentEntityPage = () => {
  const { entity } = useEntity();

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12}>
            <CommonEnvComponents.ToggleEnvironmentButton entity={entity} />
          </Grid>
          <Grid item md={12}>
            {OverviewContent}
          </Grid>
        </Grid>
      </EntityLayout.Route>
      <EntityLayout.Route path="/ci-cd" title="CI-CD">
        {CICDContent}
      </EntityLayout.Route>
    </EntityLayout>
  );
};
